import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiURL: "https://csbplab.com.au/api/",
    // apiURL: "https://labsapi.mediaengine-dev6.com.au/api/",
    //apiURL: 'https://'+window.location.hostname+'/api/',
    global: {
      minimum_price: 0.00,
    },
    menuIsOpen: false,
    menuColor: 'white',
    scroll: {
      threshold: 140,
      current: 0,
      last: 0,
      direction: 'down',
      hasScrolled: false
    },
    search: {
      total: 0,
      query: '',
      type: 'Tests and FAQ',
      criteria: 'any',
      sampleType: '',
      faqCategory: '',
      inFocus: false,
      isSearching: false,
      showTypes: false,
      sort: {
        by: 'default',
        asc: true
      }
    },
    sessionToken: {
      name: '',
      value: ''
    },
    sampleTypes: [],
    tests: [],
    calculator: {
      estimates: [],
      currentEstimate: 0,
      showDraw: false,
      showMessage: false,
      message: '',
      messageType: '',
      lastEstimatePage: '',
      prefill: {
        trading_name: '',
        account_no: '',
        contact_name: '',
        phone: '',
        po: '',
        email: '',
        abn: '',
        address: '',
        suburb: '',
        state: '',
        postcode: ''
      }
    },
    viewport: {
      width: 0,
      height: 0
    }
  },
  getters: {
    screenSize(state) {
      if (state.viewport.width < 568) {
        return "xs";
      } else if (state.viewport.width >= 568 && state.viewport.width < 768) {
        return "sm";
      } else if (state.viewport.width >= 768 && state.viewport.width < 1024) {
        return "md";
      } else if (state.viewport.width >= 1024 && state.viewport.width < 1280) {
        return "lg";
      } else if (state.viewport.width >= 1280 && state.viewport.width < 1440) {
        return "xl";
      } else {
        return "xxl";
      }
    },
    screenOrientation(state) {
      if (state.viewport.width > state.viewport.height) {
        return 'landscape';
      } else {
        return 'portrait';
      }
    },
    sampleTypes(state) {
      return state.sampleTypes;
    },
    tests(state) {
      return state.tests;
    },
    totalEstimates(state) {
      return state.calculator.estimates.length;
    },
    otherSampleTypes(state) {
      return state.sampleTypes[state.sampleTypes.length-1];
    },
    testIndexById(state) {
      return function (id) {
        const filteredItem = state.tests.find(t => t.test_id === id);
        return filteredItem.index;
      }
    },
  },
  mutations: {
    setGlobal(state, value){
      state.global = value;
    },
    setSearch(state, { key, val }) {
      state.search[key] = val;
    },
    setWindowSize(state) {
      state.viewport.width = window.innerWidth;
      state.viewport.height = window.innerHeight;
    },
    setCurrentScrollPosition(state, value) {
      state.scroll.current = value;
    },
    setLastScrollPosition(state, value) {
      state.scroll.last = value;
    },
    setScrollThreshold(state, value){
      state.scroll.threshold = value;
    },
    setScrollDirection(state, value) {
      state.scroll.hasScrolled = value;
      
      if(state.scroll.current < this.state.scroll.last) {
        state.scroll.direction = 'up';
      } else {
        state.scroll.direction = 'down';
      }
    },
    forceSetScrollDirection(state, value) {
      state.scroll.direction = value;
    },
    setFAQCategory(state,value) {
      state.faq.currentCategory = value;
    },
    setFAQItem(state,value) {
      state.faq.currentItem = value;
    },
    hasScrolledState(state, value) {
      state.scroll.hasScrolled = value;
    },
    toggleMenuState(state, value) {
      if(value){
        state.menuIsOpen = value === 'open' ? true : false;
      } else {
        state.menuIsOpen = !state.menuIsOpen;
      }
    },
    toggleDrawState(state, value) {
      if(value){
        state.calculator.showDraw = value === 'open' ? true : false;
      } else {
        state.calculator.showDraw = !state.calculator.showDraw;
      }
    },
    setMenuColor(state, value) {
      state.menuColor = value;
    },
    setSessionToken(state, value) {
      state.sessionToken.name = value.name;
      state.sessionToken.value = value.value;
    },
    setSampleTypes(state, value) {
      state.sampleTypes = value;
    },
    setTests(state, value) {
      state.tests = value;
    },
    setPrefill(state, { key, val }) {
      state.calculator.prefill[key] = val;
      
      // Save data to localStorage
      localStorage.setItem('myPrefill', JSON.stringify(state.calculator.prefill));
    },
    setLastEstimatePage(state, value) {
      state.calculator.lastEstimatePage = value;
    },
    setCurrentEstimate(state, value) {
      let currentEst = state.calculator.currentEstimate;
      let lastEst = state.calculator.estimates.length - 1;
      let newPos = 0;
        
      if (value === 'prev') {
        
        if (currentEst === 0) {
          newPos = lastEst;
        } else {
          newPos = currentEst - 1;
        }
        
      } else if (value === 'next') {
        
        if (currentEst === lastEst) {
          newPos = 0;
        } else {
          newPos = currentEst + 1;
        }
        
      } else {
        newPos = value;  
      }
      
      state.calculator.currentEstimate = newPos;
      
    },
    deleteEstimate(state, value) {
      
      if(state.calculator.estimates.length > 1) {
        state.calculator.estimates.splice(value, 1);
      } else {
        state.calculator.estimates = [];
      }
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
    },
    loadInEstimates(state, value) {
      state.calculator.estimates = value;
    },
    loadInPrefill(state, value){
      state.calculator.prefill = value;
    },
    addToEstimate(state, value) {
      var test = state.tests[value.test];
      var estimate = state.calculator.estimates[value.estimate];
      
      state.calculator.currentEstimate = value.estimate;
      
      // If a package or combination, add individual tests
      if(test.test_type <= 1 && test.children.length > 0) {
        
        let testsToAdd = state.tests.filter(t => test.children.indexOf(t.test_id) !== -1 && t.sample_type === estimate.sampleType);
        
        testsToAdd.forEach(function(ta){
          if(estimate.tests.individual.length > 0) {
            
            var alreadyExists = estimate.tests.individual.some(ti => ti.index === ta.index);
            
            if(!alreadyExists) {
              state.calculator.estimates[value.estimate].tests.individual.push(state.tests[ta.index]);
            }
          } else {
            state.calculator.estimates[value.estimate].tests.individual.push(state.tests[ta.index]);
          }
        });
      
      // If individual test, add it as it is
      } else {
        
        state.calculator.estimates[value.estimate].tests.individual.push(test);
        
      }
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
      
    },
    deleteFromEstimate(state, value) {
      var test = state.tests[value.test];
      var tests = state.calculator.estimates[value.estimate].tests.individual;
      var newTests = [];
      
      state.calculator.currentEstimate = value.estimate;
      
      // Remove child tests if package or combination
      if (test.test_type <= 1 && test.children.length > 0) {
        var optimal = state.calculator.estimates[value.estimate].tests.optimal;
        var matches = state.calculator.estimates[value.estimate].tests.matches;
        var deleteTests = [];
        
        for(var i = 0; i < optimal.length; i++) {
          
          if (optimal[i].index === test.index) {
            matches[i].forEach(function(m){
              deleteTests.push(m.index);
            });
          }
          
        }
        
        newTests = tests.filter(t => deleteTests.indexOf(t.index) === -1);
      
      // Remove individual tests or options/dependent tests
      } else {
        // Note: we still check for children because of dependents to individual tests
        newTests = tests.filter(t => t.index !== test.index && test.children.indexOf(t.test_id) === -1);
      }
      
      state.calculator.estimates[value.estimate].tests.individual = newTests;
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
    },
    createEstimate(state, value) {
      // Random seven digit number (for animation purposes, etc)
      var uid = Math.floor((Math.random() * 1000000) + 1);
      
      state.calculator.estimates.push({
        uid: 'uid-'+(uid.toFixed(7)),
        sampleType: value.sampleType,
        displayedType: value.displayedType,
        tests: {
          individual: [],
          optimal: [],
          matches: []
        },
        sampleQty: 1,
        samplePrice: 0.00,
        sampleSaving: false
      });
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
    },
    updateEstimate(state, value) {
      
      if(value.sampleType) {
        state.calculator.estimates[value.estimate].sampleType = value.sampleType;
      }
      
      if(value.displayedType) {
        state.calculator.estimates[value.estimate].displayedType = value.displayedType;
      }
      
      if(value.sampleQty) {
        state.calculator.estimates[value.estimate].sampleQty = value.sampleQty;
      }
      
      if(value.no) {
        state.calculator.estimates[value.estimate].no = value.no;
      }
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
      
    },
    optimiseEstimate(state, value) {
      state.calculator.estimates[value.estimate].tests.optimal = value.tests;
      state.calculator.estimates[value.estimate].tests.matches = value.matches;
      state.calculator.estimates[value.estimate].samplePrice = value.samplePrice;
      
      if(parseFloat(value.sampleSaving) > 0) {
        state.calculator.estimates[value.estimate].sampleSaving = value.sampleSaving;
      } else {
        state.calculator.estimates[value.estimate].sampleSaving = false;
      }
      
      // Save data to localStorage
      localStorage.setItem('myEstimates', JSON.stringify(state.calculator.estimates));
    },
    updateEstimateMessage(state, value) {
      state.calculator.message = value.message;
      state.calculator.messageType = value.type;
      state.calculator.showMessage = true;
      
      // Hide message after two seconds
      setTimeout(function(){
        state.calculator.showMessage = false;
      }, 2000);
    }
  },
  actions: {
    scrollStates({ commit, state }) {
      
      const currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
      commit('setCurrentScrollPosition', currentScrollPos);
      
      if (state.scroll.current < 0) {
        return;
      }
      
      if (Math.abs(state.scroll.current - state.scroll.last) < 5) {
        return;
      }
      
      commit('setScrollDirection');
      commit('setLastScrollPosition', state.scroll.current);
      
    },
    deleteFromEstimate({ commit, state }, data) {
      let estimate = state.calculator.estimates[data.estimate];
      
      // Delete test from estiamte
      commit('deleteFromEstimate', data);
      
      // Calculate best prices for estimates
      let response = calculateEstimate(state.tests, data.estimate, state.calculator.estimates[data.estimate], false);
      
      // Commit new best price and data to estimate
      commit('optimiseEstimate', {
        estimate: data.estimate,
        tests: response.tests,
        matches: response.matches,
        originalPrice: response.originalPrice,
        samplePrice: response.samplePrice,
        sampleSaving: response.sampleSaving
      });
      
      // Update the message
      commit('updateEstimateMessage', {
        message: 'Your test has been removed from <br><strong>'+estimate.displayedType+' Estimate ('+(data.estimate+1)+')</strong>',
        type: 'success'
      });
    },
    addToEstimate({ commit, state }, data) {
      
      // For handling multiple test submissions
      var tests = data.test;
      
      // 'data.tests' is not an array, make it an array and overwrite 'tests' variable
      if(!Array.isArray(data.test)) {
        tests = [data.test];
      }
      
      // Existing Estimate
      if(data.estimate !== false) {
        let estimate = state.calculator.estimates[data.estimate];
        let existingTests = 0;
        
        tests.forEach(function(test){
          
          if(estimate.tests.individual.some(t => t.index === test) || estimate.tests.optimal.some(t => t.index === test)) {
            
            existingTests++;
            
          } else {
            
            // Add test to estimate
            commit('addToEstimate', {test: test, estimate: data.estimate});
            
          }
            
        });
        
        if(existingTests === tests.length) {
          
          // Message
          commit('updateEstimateMessage', {
            message: 'This test is already in <br><strong>'+estimate.displayedType+' Estimate ('+(data.estimate+1)+')</strong>',
            type: 'warning'
          });
          
        } else {

          // Calculate best prices for estimates
          let response = calculateEstimate(state.tests, data.estimate, state.calculator.estimates[data.estimate], true);
          
          // Commit new best price and data to estimate
          commit('optimiseEstimate', {
            estimate: data.estimate,
            tests: response.tests,
            matches: response.matches,
            originalPrice: response.originalPrice,
            samplePrice: response.samplePrice,
            sampleSaving: response.sampleSaving
          });
          
          // Update the message
          commit('updateEstimateMessage', {
            message: response.message,
            type: response.messageType
          });
          
        }
      
      // New Estimate
      } else {
        let estimateIndex = state.calculator.estimates.length;
        let sampleType = state.tests[tests[0]].sample_type;
        
        let displayTypes = ['Soil','Plant','Carbon (CFI)','Water'];
        let displayedType = sampleType;
        
        if(displayTypes.indexOf(sampleType) === -1) {
          displayedType = 'Other';
        }
        
        // Create a blank new estimate
        commit('createEstimate', {sampleType: sampleType, displayedType: displayedType});
        
        tests.forEach(function(test){
          // Add to the new estimate
          commit('addToEstimate', {
            test: test,
            estimate: estimateIndex
          });
        });
        
        // Calculate best prices for estimates
        let response = calculateEstimate(state.tests, estimateIndex, state.calculator.estimates[estimateIndex], false);
        
        // Commit new best price and data to estimate
        commit('optimiseEstimate', {
          estimate: estimateIndex,
          tests: response.tests,
          matches: response.matches,
          originalPrice: response.originalPrice,
          samplePrice: response.samplePrice,
          sampleSaving: response.sampleSaving
        });
        
        // Message
        commit('updateEstimateMessage', {
          message: 'You just created a new <br><strong>'+displayedType+' Estimate</strong>',
          type: 'success'
        });
      }
      
    }
  }
})


// CUSTOM CALCULATIONS
// Trigger calculations
function calculateEstimate(tests, estimateIndex, estimate, includeMessage){
  
  // Calculate best prices for estimates
  var response = calculateSelections(tests, {tests: estimate.tests.individual, sampleType: estimate.sampleType, recursion: 0, exempt: false});
  
  // Selection price
  var initialValue = 0;
          
  var selectionPrice = response.selection.reduce(function (accumulator, currentValue) {
    return accumulator + parseFloat(currentValue.price)
  }, initialValue);
  
  
  // Original price
  initialValue = 0;
  
  var originalPrice = estimate.tests.individual.reduce(function (accumulator, currentValue) {
    return accumulator + parseFloat(currentValue.price)
  }, initialValue);
  
  
  // Final variables
  var samplePrice = selectionPrice.toFixed(2);
  var sampleSaving = (originalPrice - selectionPrice).toFixed(2);
  
  // Determine message
  let message = '';
  let messageType = 'success';
  
  if(includeMessage) {
    if(parseFloat(estimate.sampleSaving) === 0 || estimate.sampleSaving === sampleSaving) {
      // Message where no savings were made
      message = 'Your test has been added to <br><strong>'+estimate.displayedType+' Estimate ('+(estimateIndex+1)+')</strong>';
      messageType = 'success';
      
    } else {
      
      // Message where savings where made
      let totalPackages = 0;
      let totalCombinations = 0;
      
      response.selection.forEach(function(s){
        if(s.test_type === 0) {
          totalPackages++;
        }
        
        if(s.test_type === 1) {
          totalCombinations++;
        }
      });
      
      if(totalPackages > 0 && totalCombinations === 0) {
        message = 'You just saved with a <br><strong>Package</strong>';
        messageType = 'package';
        
      } else if(totalCombinations > 0 && totalPackages === 0) {
        message = 'You just saved with a <br><strong>Combine and Save</strong>';
        messageType = 'combination';
        
      } else if(totalPackages > 0 && totalCombinations > 0) {
        message = 'You just saved with a <br><strong>Package + Combine and Save</strong>';
        messageType = 'success';
        
      } else if(totalCombinations === 0 && totalPackages === 0 && estimate.tests.individual.length > response.selection.length) {
        message = 'Some tests were combined <br>into a single test';
        messageType = 'success';
      }
      
    }
  }
  
  return {
    tests: response.selection,
    matches: response.matches,
    samplePrice: samplePrice,
    originalPrice: originalPrice,
    sampleSaving: sampleSaving,
    message: message,
    messageType: messageType
  };
}


// Selection logic
function calculateSelections(tests, data){
    
  // Main test storage
  var selections = [];
  var selectionMatches = [];
  var found = 0;
  
  // Sort tests highest price to lowest (important for getting lowest possible end price)
  data.tests.sort(function(a,b){
    var aPrice = parseFloat(a.price);
    var bPrice = parseFloat(b.price);
    
    if ( aPrice > bPrice ){
      return -1;
    }
    if ( aPrice < bPrice ){
      return 1;
    }
    
    return 0;
  });
  
  // Get relevant packages (type = 0 or 1  |  type = Package or Combination)
  var packagesAndCombinations = tests.filter(p => p.test_type <= 1 && p.sample_type === data.sampleType);
  
  var ingorePacks = data.exempt;
  
  if(!ingorePacks) {
    ingorePacks = [];
  }
  
    
  // Loop through possible packages and combinations
  packagesAndCombinations.forEach(function(pack){
    
    if(ingorePacks.indexOf(pack.index) === -1) {
      
      var matchingPrice = 0;
      var matches = [];
      var remaining = [];
      
      // Loop through each test
      data.tests.forEach(function(e){
        
        // If it is in package/combination
        if(pack.children.indexOf(e.test_id) !== -1) {
          
          // If package ignore count test as packages should equal the maximum child tests
          if(pack.test_type === 0) {
            matches.push(e);
            matchingPrice += parseFloat(e.price);
          }
          
          // If combination, make sure the total number of matches are identical to child test qty
          if(pack.test_type === 1) {
            
            if(matches.length < pack.child_test_qty) {
              matches.push(e);
              matchingPrice += parseFloat(e.price);
              
            // If total matches is equal to or more, store in remaining
            } else {
              remaining.push(e);
            }
            
          }
        
        // If not in package, store in remaining
        } else {
          remaining.push(e);
        }
        
        
      });
      
      
      
      
      // Can make a selection
      if((pack.test_type === 0 && matches.length === pack.children.length) || (pack.test_type === 1 && matches.length === pack.child_test_qty)) {
        
        
        // If matching total price is greater than package/combo price, then proceed
        if(matchingPrice >= parseFloat(pack.price)) {
          
          // Package/combo has matched... tell parent function that it has found something
          found++;
                              
          // If there are remaining tests, check again.
          if(remaining.length > 0) {
            
            // Handle duplicates with exemptions (i.e. we don't want two '2 Basic Tests' when we could just have one '4 Basic Tests'
            var exempts = [];
            
            // If previous iteration had exemptions, then merge it with new exemption
            if(data.exempt) {
              exempts = data.exempt;
              exempts.push(pack.index);
            } else {
              exempts.push(pack.index);
            }
            
            var response = calculateSelections(tests, {tests: remaining, sampleType: data.sampleType, recursion: data.recursion+1, exempt: exempts});
            
            var arr = [pack];
            var mat = [matches];
            var newArr = false;
            var newMatch = false;
            
            if (response.found > 0) {
              newArr = arr.concat(response.selection);
              selections.push(newArr);
              
              newMatch = mat.concat(response.matches);
              selectionMatches.push(newMatch);
              
            } else {
              newArr = arr.concat(remaining);
              selections.push(newArr);
              
              var rems = [];
              remaining.forEach(function(){
                rems.push(false);
              });
              
              newMatch = mat.concat(rems);
              selectionMatches.push(newMatch);
              
              
            }
            
          } else {
            
            selections.push([pack]);
            selectionMatches.push([matches]);
            
          }
          
        }
        
      }
    }
    
  });
  
  var selection = [];
  var selectionMatch = [];
  
  // If no results
  if(found === 0) {
    selection = data.tests;
    
    data.tests.forEach(function(){
      selectionMatch.push(false);
    });
    
  // If has results, find cheapest result
  } else {
    
    // Add original list of individual tests to response (so we an compare)
    selections.push(data.tests);
    
    // Find cheapest price with lowest object count
    var cheapestPrice = false;
    var cheapestOption = false;
    var lowestSelectionCount = false;
    
    for(var s = 0; s < selections.length; s++) {
      
      // Get selection price total
      var initialValue = 0;
            
      var price = selections[s].reduce(function (accumulator, currentValue) {
        return accumulator + parseFloat(currentValue.price)
      }, initialValue);
      
      // Get selection item total
      var totalSelections = selections[s].length;
      
      
      // If first item, set default cheapest option
      if (s === 0) {
        
        cheapestPrice = price;
        cheapestOption = s;
        lowestSelectionCount = totalSelections;
      
      } else {
        
        // If cheaper than current cheapest price
        if(price < cheapestPrice) {
          cheapestPrice = price;
          cheapestOption = s;
          lowestSelectionCount = totalSelections;
        }
        
        // If is same price, check if it has less items
        if(price === cheapestPrice && totalSelections < lowestSelectionCount) {
          cheapestPrice = price;
          cheapestOption = s;
          lowestSelectionCount = totalSelections;
        }
        
      }
      
    }
    
    selection = selections[cheapestOption];
    selectionMatch = selectionMatches[cheapestOption];
    
  }
  
  // Return the best priced selection (if any)
  return {selection: selection, matches: selectionMatch, found: found};
}